import { render, staticRenderFns } from "./TComboboxButton.vue?vue&type=template&id=2a4ca96c&scoped=true&"
import script from "./TComboboxButton.vue?vue&type=script&lang=js&"
export * from "./TComboboxButton.vue?vue&type=script&lang=js&"
import style0 from "./TComboboxButton.vue?vue&type=style&index=0&id=2a4ca96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ca96c",
  null
  
)

/* custom blocks */
import block0 from "./TComboboxButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports